import "../styles/story.css";
// import storyImage from '../../images/mapMarker.webp'

export default function Twentythree() {
  return (
    <div className="containerStory">
      <div className="storyHeading">
        <h2>2023</h2>
        {/* <img src={storyImage} alt="Tubbees Coatbridge store" /> */}
      </div>

      <p>
        We continued to grow, opening a new Tubbees store in Coatbridge.
        <br />
        <span>
          Bringing our slushees, desserts and imported treats to even more
          customers across Lanarkshire.
        </span>
      </p>
    </div>
  );
}